import {PriceContext} from "../context/PriceContext";
import React, {useContext} from "react";

const Price = () => {
    const priceContext = useContext(PriceContext);

    return (
        <div>
            <div className="h3">Cena Brutto: {priceContext.priceGross.toFixed(2)} zł</div>
            <div  className="h3">Cena Netto: {priceContext.priceNett.toFixed(2)} zł</div>
        </div>
    );
};
export default Price;
